import client from '@/clients/customer/api-client';
import Qs from 'qs';

export const getShopProducts = (filter: any | null = null, headers = {}) => {
  return client.get('/shop-products', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });
};
